import { AngularSvgIconModule, provideAngularSvgIcon } from 'angular-svg-icon';
import {
  buildings,
  calendarWeek,
  chatDotsFill,
  clipboardCheck,
  exclamationTriangleFill,
  eyeFill,
  eyeSlashFill,
  headset,
  journalBookmarkFill,
  NgxBootstrapIconsModule,
  pinMapFill,
  recycle,
  star,
  starFill,
  truck,
} from 'ngx-bootstrap-icons';

import {
  GoogleLoginProvider,
  GoogleSigninButtonModule,
  SOCIAL_AUTH_CONFIG,
  SocialAuthServiceConfig,
  SocialLoginModule,
} from '@abacritt/angularx-social-login';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

import { Environment } from '../../share/services/environment.service';
import { RequestIdInterceptor } from '../../auth/src/request-id.interceptor';
import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';

const environment = new Environment();
const icons = {
  star,
  starFill,
  eyeFill,
  eyeSlashFill,
  buildings,
  pinMapFill,
  exclamationTriangleFill,
  calendarWeek,
  truck,
  chatDotsFill,
  recycle,
  clipboardCheck,
  journalBookmarkFill,
  headset,
};

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    provideRouter(routes),
    importProvidersFrom(
      NgbDropdownModule,
      SocialLoginModule,
      ReactiveFormsModule,
      SocialLoginModule,
      NgxBootstrapIconsModule.pick(icons),
      AngularSvgIconModule.forRoot(),
      GoogleSigninButtonModule,
    ),
    {
      provide: SOCIAL_AUTH_CONFIG,
      useValue: {
        autoLogin: true,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(environment.googleId, {
              oneTapEnabled: true,
            }),
          },
        ],
        onError: (err) => {
          console.error(err);
        },
      } as SocialAuthServiceConfig,
    },
    { provide: HTTP_INTERCEPTORS, useClass: RequestIdInterceptor, multi: true },
    provideHttpClient(withInterceptorsFromDi()),
    provideAngularSvgIcon(),
  ],
}).catch((err) => console.error(err));
